// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.quick-link-item{text-align:center;width:110px}.quick-link-item__link{color:#406363;text-decoration:none;transition:color .3s}.quick-link-item__link:hover{color:#a35926}.quick-link-item__image{height:54px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
